import { Empty, Switch, Pagination } from 'antd'
import { Icon } from '@iconify/react'
import { useCallback, useEffect, useState } from 'react'
import { deleteGenofenceInfo, getGenofenceInfo, getLocalAndroidAll, updateGenofenceInfo } from 'src/@api/dashboard'
import { useRouter } from 'next/router'
import qs from 'qs'
import axios from 'axios'
import { messageInfo } from 'src/components/Message'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'src/utils/i18n'
import { setCurrentTab } from 'src/store/apps/Common'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import { readLocalDeviceUdid, readUserEmail } from 'src/utils/readAndroidLocalContext'

import Image from 'next/image'
import ContentLoading from 'src/components/ContentLoading'

const Geofence = () => {
  const dispatch = useDispatch()

  const router = useRouter()
  const [selector, updateSelector] = useState(0)
  const [geofenceInfoList, updateGeofenceInfoList] = useState([])
  const [total, setTotal] = useState(0)
  const [page, updatePage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)

  const selectorItem = id => {
    updateSelector(id)
  }

  /**
   * 切换数据状态
   * @param { number } id 切换状态的数据 id
   */
  const toggleGeofenceStatus = id => {
    for (const info of geofenceInfoList) {
      if (info.id === id) {
        info.status = !info.status
        updateGenofenceInfo({
          ...info,
          device_id: readLocalDeviceUdid()
        }).then(({ msg, code }) => {
          if (code) {
            messageInfo(msg)
          } else {
            messageInfo(msg)
            onChangePage()
          }
        })
      }
    }
  }

  /**
   * 删除数据
   * @param { number } id 删除的数据 id
   * @param { number } index 删除的数据索引
   */
  const removeGeofence = (id = -1, index = -1) => {
    if (!geofenceInfoList.length > index) return
    if (geofenceInfoList.filter(v => v.id === id).length) {
      geofenceInfoList.splice(index, 1)
      updateGeofenceInfoList(geofenceInfoList)
      deleteGenofenceInfo({ device_id: readLocalDeviceUdid(), id }).then(
        ({ code, msg }) => {
          if (code) messageInfo(msg)
          else messageInfo(msg)

          onChangePage()
        }
      )
    }
  }

  /**
   * 更改分页回调
   * @param { number } page 分页页码
   */
  const onChangePage = useCallback((page = 1, { isCurrent } = {}) => {
    // 翻页/刷新列表不盖整页 ContentLoading，仅首屏/设备切换用 isLoading
    getGenofenceInfo({ device_id: readLocalDeviceUdid(), page })
      .then(({ data, msg, code, total }) => {
        if (isCurrent && !isCurrent()) return

        if (code) messageInfo(msg)
        else updateGeofenceInfoList(data || [])
        updatePage(page)
        setTotal(total)
        setIsLoading(false)
      })
      .catch(() => {
        if (isCurrent && !isCurrent()) return
        setIsLoading(false)
      })
  }, [])

  /**
   * 跳转到设置数据页面
   * @param { number } id 可选的数据 id， 传入则为修改
   */
  const toSetGeofenceInfo = (id = -1) => {
    if (~id) {
      for (const info of geofenceInfoList) {
        if (info.id === id) {
          const params = {
            id: info.id,
            name: info.name,
            radius: info.radius,
            latlng: info.latlng,

            // start_time: info.start_time,
            // end_time: info.end_time,
            // week: info.week,
            email_notification: info.email_notification,
            status: info.status
          }
          router.push(`/android/local/set-geofence?` + qs.stringify(params))
          break
        }
      }
    } else {
      router.push(`/android/local/set-geofence`)
    }
  }

  /**
   * 创建数据内容
   */
  const createGeofenceInfo = () => {
    toSetGeofenceInfo()
  }

  // 设备切换时重置围栏列表并重新拉数
  useDeviceScopedInit(
    useCallback(
      (_, { isCurrent }) => {
        setIsLoading(true)
        updateGeofenceInfoList([])
        updatePage(1)
        setTotal(0)
        onChangePage(1, { isCurrent })
      },
      [onChangePage]
    )
  )

  const { t } = useTranslation('common')

  const [current, setCurrent] = useState(0)

  // 选择日期
  const [startTime, setStartTime] = useState('')
  const [endTime, setEndTime] = useState('')

  // 地图中心点（与 android/local/locations 页保持一致）
  const [mapCenter, setMapCenter] = useState({ lat: 40.7143528, lng: -74.0059731 })

  let Advanced = window.localStorage.getItem('currentDevice')
  Advanced = Advanced == null || Advanced != '{}' ? false : true

  // 获取地理位置
  let location = async (latitude, longitude) => {
    try {
      let result = await axios({
        url: `${process.env.NEXT_PUBLIC_LONGITUDE_KEY}?latitude=${latitude}&longitude=${longitude}`,
        method: 'get'
      })

      let location = `${result.data.countryName} ${result.data.city} ${result.data.locality}`

      return `${location}`
    } catch (error) {
      return ''
    }
  }

  // 获取基础gps
  let basicGps = async (page, pageSize) => {
    setFlag(true)

    let params = {
      category: 'LOCATION',
      offset: page,
      limit: pageSize,
      deviceUdid: readLocalDeviceUdid()
    }

    startTime == '' ? null : (params.startTime = startTime)
    endTime == '' ? null : (params.endTime = endTime)

    let response = await getLocalAndroidAll({
      username: readUserEmail(),
      params
    })
    let result = response.data.contents
    if (result != null) {
      result = positiondata.concat(response.data.contents)
      setTotal(response.data.totalCount)
    }
    if (result > 0) {
      setMapCenter({
        lat: result[0].latitude,
        lng: result[0].longitude
      })
    }

    let newArr = result

    if (result != null) {
      localStorage.removeItem('gpsLocations')
      for (let i = 0; i < newArr.length; i++) {
        if (typeof newArr[i].position == 'undefined') {
          newArr[i].position = await location(`${result[i].latitude}`, `${result[i].longitude}`)

          // newArr[i].position = '50'
        }

        newArr[i].id = i + 1
      }

      let positionDataList = result.map(item => {
        return {
          ...item,
          lat: item.latitude,
          lng: item.longitude
        }
      })

      setFlag(false)
      setPositiondata(positionDataList)
      setMapPositiondata(positionDataList)

      setMapdata(result[0])
      setBgdata(positionDataList[0].id)
    }
  }

  // 获取高级gps
  let advancedGps = async (page, pageSize) => {
    setFlag(true)

    let params = {
      category: 'LOCATION',
      offset: page,
      limit: pageSize,
      deviceUdid: readLocalDeviceUdid()
    }

    startTime == '' ? null : (params.startTime = startTime)
    endTime == '' ? null : (params.endTime = endTime)

    let response = await getLocalAndroidAll({
      username: readUserEmail(),
      params
    })

    setFlag(false)

    let result = response.data.contents

    if (result != null) {
      result = positiondata.concat(response.data.contents)

      setTotal(response.data.totalCount)
    }

    if (result > 0) {
      setMapCenter({
        lat: result[0].latitude,
        lng: result[0].longitude
      })
    }

    // let newArr = result.filter((obj, index, self) => {
    //   console.log(obj, index, self, 456)

    //   return index === self.findIndex(o => o.timeStamp === obj.timeStamp)
    // })
    let newArr = result

    if (result != null) {
      localStorage.removeItem('gpsLocations')
      for (let i = 0; i < newArr.length; i++) {
        if (typeof newArr[i].position == 'undefined') {
          newArr[i].position = await location(`${result[i].latitude}`, `${result[i].longitude}`)

          // newArr[i].position = 10
        }

        newArr[i].id = i + 1
      }

      let positionDataList = newArr.map(item => {
        return {
          ...item,
          lat: item.latitude,
          lng: item.longitude
        }
      })

      setPositiondata(positionDataList)
      setMapPositiondata(positionDataList)

      setMapdata(result[0])

      setBgdata(positionDataList[0].id)
    }
  }

  const setLocation = async data => {
    // 判断是要不要获取高级版gps
    if (Advanced) {
      if (page === 1 && positiondata.length === 0) {
        //首次加载10
        await basicGps((page - 1) * 30, 10)
      } else if (positiondata.length === 10) {
        //首次获取完 再取20
        await basicGps((page - 1) * 30, 20)
      } else {
        //手动点击
        await basicGps((page - 1) * 30, 30)
      }
    } else {
      if (page === 1 && positiondata.length === 0) {
        //首次加载10
        await advancedGps((page - 1) * 30, 10)
      } else if (positiondata.length === 10) {
        //首次获取完 再取20
        await advancedGps((page - 1) * 30, 20)
      } else {
        //手动点击
        await advancedGps((page - 1) * 30, 30)
      }
    }

    const _arr = []

    for (const item of geofenceInfoList) {
      item.position = item.name
    }

    // updateGeofenceInfoList([_arr])
  }

  const [positiondata, setPositiondata] = useState([])
  const [mapPositiondata, setMapPositiondata] = useState([])
  const [flag, setFlag] = useState(false)
  const [mapdata, setMapdata] = useState({})
  const [markers, setMarkers] = useState(null)
  const [bgdata, setBgdata] = useState(0)

  var map = ''

  //首次取完 再取20
  useEffect(() => {
    if (positiondata.length === 10) {
      setLocation()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positiondata.length])

  useEffect(() => {
    setLocation()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (geofenceInfoList.length !== 0) {
      var mapContainer = document.getElementById('LeafletMap')
      if (mapContainer) {
        var parent = mapContainer.parentNode
        parent.removeChild(mapContainer)
      }

      // 获取父元素
      var leafletContainer = document.getElementById('leaflet')

      if (leafletContainer) {
        // 创建子元素 div
        var mapDiv = document.createElement('div')
        mapDiv.id = 'LeafletMap'

        // 将子元素添加到父元素中
        leafletContainer.appendChild(mapDiv)
      }

      // 创建地图容器并初始化地图
      console.log('aaa', geofenceInfoList)
      map = L.map('LeafletMap').setView(
        [geofenceInfoList[0].latlng.split(',')[0], geofenceInfoList[0].latlng.split(',')[1]],
        geofenceInfoList.length == 1 ? 18 : 13
      )
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19
      }).addTo(map)

      /* 坐标icon */
      const customIcon = L.icon({
        iconUrl: 'https://demo.mobilespy.io/assets/images/icons/map-marker.svg',
        iconSize: [50, 50],
        iconAnchor: [16, 32]
      })

      // 创建一个MarkerClusterGroup对象，自定义聚合图标
      // setMarkers(
      //   new L.MarkerClusterGroup({
      //     iconCreateFunction: function (cluster) {
      //       var childCount = cluster.getChildCount()

      //       var customIconHtml =
      //         '<div class="custom-cluster-icon">' +
      //         '<img src="/images/gps/m2.png" class="custom-cluster-icon">' +
      //         '<div class="cluster-count">' +
      //         childCount +
      //         '</div>' +
      //         '</div>'

      //       return L.divIcon({
      //         html: customIconHtml,
      //         className: 'custom-cluster-wrapper', // 自定义样式的类名
      //         iconSize: [50, 50]
      //       })
      //     }
      //   })
      // )
      let markers = new L.MarkerClusterGroup({
        iconCreateFunction: function (cluster) {
          var childCount = cluster.getChildCount()

          var customIconHtml =
            '<div class="custom-cluster-icon">' +
            '<img src="/images/gps/m2.png" class="custom-cluster-icon">' +
            '<div class="cluster-count">' +
            childCount +
            '</div>' +
            '</div>'

          return L.divIcon({
            html: customIconHtml,
            className: 'custom-cluster-wrapper', // 自定义样式的类名
            iconSize: [50, 50]
          })
        }
      })

      if (markers == null) return

      // 添加标记到MarkerClusterGroup
      let coordinates = []

      // 每个标记的弹出框内容
      let popupContents = []

      geofenceInfoList.forEach(item => {
        coordinates.push([item.latlng.split(',')[0], item.latlng.split(',')[1]])
      })

      geofenceInfoList.forEach(item => {
        popupContents.push(item.name)
      })

      // 遍历坐标数组并添加标记到MarkerClusterGroup
      coordinates.forEach(function (coord, index) {
        var marker = L.marker(coord, { icon: customIcon })

        // 为每个标记添加点击事件和不同的弹出框内容
        marker.bindPopup(popupContents[index])

        marker.on('click', function () {
          map.setView(coord, 20) // 设置视图以当前坐标为中心，缩放级别为16（根据需要进行调整）
        })

        markers.addLayer(marker)
      })

      map.addLayer(markers)

      // 获取标记的坐标
      var latlngs = coordinates.map(function (coord) {
        return L.latLng(coord[0], coord[1])
      })

      // 自定义连线的样式
      var customLineStyle = {
        color: 'blue', // 线的颜色
        weight: 2, // 线的宽度
        opacity: 0.7 // 线的不透明度
      }

      // 创建Polyline对象并将其添加到地图，应用自定义样式
      L.polyline(latlngs, customLineStyle).addTo(map)

      // 为MarkerClusterGroup添加点击事件
      markers.on('clusterclick', function (event) {
        // 获取点击的聚合的中心点坐标
        var clusterCenter = event.latlng

        // 放大地图到最大缩放级别
        map.setView(clusterCenter, map.getMaxZoom())
      })

      // 为MarkerClusterGroup添加点击事件
    } else {
      if (mapPositiondata.length !== 0) {
        var mapContainer = document.getElementById('LeafletMap')
        if (mapContainer) {
          var parent = mapContainer.parentNode
          parent.removeChild(mapContainer)
        }

        // 获取父元素
        var leafletContainer = document.getElementById('leaflet')

        if (leafletContainer) {
          // 创建子元素 div
          var mapDiv = document.createElement('div')
          mapDiv.id = 'LeafletMap'

          // 将子元素添加到父元素中
          leafletContainer.appendChild(mapDiv)
        }

        // 创建地图容器并初始化地图

        map = L.map('LeafletMap').setView(
          [mapPositiondata[0].lat, mapPositiondata[0].lng],
          mapPositiondata.length == 1 ? 18 : 13
        )
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19
        }).addTo(map)
      }
    }
  }, [geofenceInfoList, current, mapPositiondata])

  useEffect(() => {
    dispatch(setCurrentTab(t('Geofence')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  if (isLoading && geofenceInfoList.length === 0) {
    return (
      <div className='relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex'>
        <ContentLoading />
      </div>
    )
  }

  return (
    <>
      {geofenceInfoList.length === 0 ? (
        <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] overflow-auto flex flex-col Blds:drop-shadow-none'>
          <div className='w-full pt-[15px] pb-[20px] Blds:absolute Blds:top-0 Blds:z-[999] Blds:bg-[#FFF] Blds:rounded-[10px] Blds:w-[375px] Blds:mt-[12px] Blds:ml-[16px] Blds:drop-shadow-[0_0_12px_rgba(0,0,0,0.13)]'>
            <p className='text-[15px] Blds:text-[16px] text-[#11141A] text-center font-[600]'>
              {t('No zones configured')}
            </p>
            <p className='mt-[5px] w-[260px] text-[13px] Blds:text-[14px] text-[#9198AD] text-center mx-auto'>
              {t('Add a new zone to track when your kid enters or leaves a specific area')}
            </p>
            <button
              className={`mt-[10px] w-[220px] h-[34px] bg-[#FFCF55] rounded-[23px] text-[14px] Blds:text-[16px] font-[600] text-[#1B1C2B] flex items-center justify-center mx-auto`}
              onClick={createGeofenceInfo}
            >
              <Image className='mr-[9px]' src='/images/geofence/add.svg' width={12} height={12} alt='add' />
              {t('New zone')}
            </button>
          </div>
          <div className='flex-1 GPS' id='leaflet'>
            <div id='LeafletMap' style={{ height: '100%', width: '100%' }}></div>
          </div>
        </div>
      ) : (
        <>
          <div className='mb-[14px] w-full flex justify-center Blds:hidden'>
            <div className='flex p-[2px] bg-[#EAEAEA] rounded-[8px]  text-[14px] font-[600]'>
              <div
                className={`${current == 0 ? 'rounded-[6px] bg-[#FFF] text-[#2405F2]' : 'text-[#000]'
                  } px-[18px] py-[5px] mr-[2px] cursor-pointer`}
                onClick={() => setCurrent(0)}
              >
                {t('Zones')}
              </div>
              <div
                className={`${current == 1 ? 'rounded-[6px] bg-[#FFF] text-[#2405F2]' : 'text-[#000]'
                  } px-[18px] py-[5px] cursor-pointer`}
                onClick={() => setCurrent(1)}
              >
                {t('Map')}
              </div>
            </div>
          </div>
          <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Mlg:h-[calc(var(--vh2)*100-140px)] lg:Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] overflow-auto Blds:relative Blds:drop-shadow-none'>
            <div
              className={`${current == 0 ? '' : 'hidden Blds:block'
                } w-full px-[18px] Blds:absolute Blds:top-[12px] Blds:left-[16px] Blds:z-[999] Blds:bg-[#FFF] Blds:w-[375px] Blds:rounded-[10px] Blds:pb-[24px] Blds:drop-shadow-[0_0_12px_rgba(0,0,0,0.13)]`}
            >
              {geofenceInfoList.map((item, index) => (
                <div key={item.id} className='w-full h-[38px] mt-[24px] flex justify-between'>
                  <div className='flex overflow-hidden flex-1'>
                    <Image
                      src={`/images/geofence/${item.status ? 'allowed' : 'restricted'}.svg`}
                      width={38}
                      height={38}
                      alt='allowed'
                    ></Image>
                    <div className='flex flex-col justify-center ml-[10px] overflow-hidden'>
                      <div className='text-[12px] Blds:text-[14px] text-[#000] font-[600] overflow-hidden text-nowrap text-ellipsis'>
                        {item.name}
                      </div>
                      <div
                        className={`${item.status ? 'text-[#2A99FF]' : 'text-[#F33737]'} text-[12px] Blds:text-[14px]`}
                      >
                        {item.status ? <>{t('Allowed')}</> : <>{t('Restricted')}</>}
                      </div>
                    </div>
                  </div>
                  <div className='flex items-center'>
                    <Image
                      className='cursor-pointer'
                      src='/images/geofence/del.svg'
                      width={24}
                      height={24}
                      alt='del'
                      onClick={() => removeGeofence(item.id, index)}
                    ></Image>
                    <Image
                      className='mx-[16px] cursor-pointer'
                      src='/images/geofence/edit.svg'
                      width={24}
                      height={24}
                      alt='edit'
                      onClick={() => toSetGeofenceInfo(item.id)}
                    ></Image>
                    <Switch value={item.status} onChange={() => toggleGeofenceStatus(item.id)} />
                  </div>
                </div>
              ))}

              <button
                className={`mt-[36px] w-full h-[34px] bg-[#FFCF55] rounded-[23px] text-[14px] Blds:text-[16px] font-[600] text-[#1B1C2B] flex items-center justify-center mx-auto`}
                onClick={createGeofenceInfo}
              >
                <Image className='mr-[9px]' src='/images/geofence/add.svg' width={12} height={12} alt='add' />
                {t('New zone')}
              </button>
            </div>

            <div
              className={`${current == 1 ? '' : 'hidden Blds:block'
                } w-full h-[calc(var(--vh2)*100-139px)] Blds:h-[calc(var(--vh2)*100-90px)] GPS`}
              id='leaflet'
            >
              <div id='LeafletMap' style={{ height: '100%', width: '100%' }}></div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
export default Geofence



// <div className='w-full h-[60rem] bg-white rounded-md shadow-[0_0_.5rem_0_gray] flex flex-nowrap justify-center items-center flex-row  sm:flex-col'>
//   <div className='w-[40%] h-full flex flex-col justify-between items-center sm:w-[100%]'>
//     <ul className='w-full'>
//       {console.log('geofenceInfoList', geofenceInfoList)}
//       {geofenceInfoList.map((v, index) => {
//         return (
//           <li
//             key={v.id}
//             onClick={() => selectorItem(v.id)}
//             className={`w-full hover:cursor-pointer  ${selector === v.id ? 'bg-[#00eeff3f]' : ''} ${
//               index % 2 !== 0 ? 'border-y-[1px]' : ''
//             }`}
//           >
//             <div className='w-full h-full flex flex-row justify-between items-center py-6 px-10 mx-2'>
//               <div className='w-[2rem]'>
//                 <Icon icon='gis:poi-alt-o' style={{ color: '#00aeffc5' }} className='w-[2rem] h-[1.5rem]' />
//               </div>
//               <div className='w-[40%] px-1 overflow-hidden text-ellipsis'>{v.name}</div>
//               <div className='w-[3rem]'>
//                 <Switch
//                   value={v.status}
//                   onChange={() => toggleGeofenceStatus(v.id)}
//                   className='bg-[hsla(0,100%,0%,.2)] w-12rem'
//                 />
//               </div>
//               <div className='h-full w-[2rem]'>
//                 <Icon
//                   className='w-[1.5rem] h-[1.2rem] mx-2'
//                   icon='jam:write-f'
//                   onClick={() => toSetGeofenceInfo(v.id)}
//                   style={{ color: '#00aeffc5' }}
//                 />
//               </div>
//               <div className='h-full w-[3rem]'>
//                 <Icon
//                   className='w-[1.5rem] h-[1.5rem] mx-2'
//                   icon='material-symbols:delete-outline'
//                   onClick={() => removeGeofence(v.id, index)}
//                   style={{ color: '#00aeffc5' }}
//                 />
//               </div>
//             </div>
//           </li>
//         )
//       })}
//     </ul>
//     {!!total && (
//       <div className='h-8 w-[80%] flex flex-row justify-center items-center'>
//         <Pagination
//           hideOnSinglePage
//           defaultCurrent={page}
//           total={total}
//           onChangePage={onChangePage}
//           itemRender={(page, type, el) => {
//             if (type === 'prev') return <Icon icon='ant-design:left-outlined' className='h-full' />
//             if (type === 'next') return <Icon icon='ant-design:right-outlined' className='h-full' />

//             return el
//           }}
//         />
//       </div>
//     )}
//     <button
//       className='w-[80%] h-16 flex justify-center items-center rounded-xl border-2 border-[skyblue] border-dashed mb-10 text-[#50cdff] p-2'
//       onClick={createGeofenceInfo}
//     >
//       <Icon icon='carbon:add-filled' className='h-10 w-10 mr-2' />
//       <span className='text-[1.2rem]'>{t('Add a geofence')}</span>
//     </button>
//   </div>
//   <div className='w-[60%] h-full border-l-[1px] sm:w-[100%]'>
//     <div className='w-full h-[20rem] flex flex-row justify-center items-center'>
//       <Empty
//         description={t('No Result')}
//         image={Empty.PRESENTED_IMAGE_SIMPLE}
//         className='text-[2rem] leading-[5rem]'
//         imageStyle={{ transform: 'scale(2)' }}
//       />
//     </div>
//   </div>
// </div>
